export default {
    getSector() {
        return ["기타", "초등", "중등", "고등", "중고등", "초중고", "대학", "오피스", "산업체", "연수원", "관공서", "병원", "요양", "복지", "유아", "영아", "행사"]
    }
}